import React from "react";
import { Badge } from "react-bootstrap";
import { subtleBadgeProps } from "@core/utils/subtleBadge";

const StatusPill: React.FC<{ active: boolean; className?: string }> = ({ active, className }) => {
    return (
        <Badge
            {...subtleBadgeProps(active ? "success" : "secondary", className)}
            pill
            data-testid="status-pill"
        >
            {active ? "Active" : "Inactive"}
        </Badge>
    );
};

export default StatusPill;